import { Container } from './styles'

export const RegressiveCounter = ({ size, maxSize }) => {
  return (
    <Container className='counter' size={size} maxSize={maxSize}>
      <span>{size}/{maxSize}</span>
    </Container>
  )
}